import { Alert, Modal, Stack, Text } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { useAuthStore } from './auth-store';
import { ChangePasswordForm } from './ChangePasswordForm';

/**
 * App-wide modal rendered at the shell level. When the current user has
 * must_change_password=true, this is undismissible until the API confirms a
 * successful password change (at which point fetchMe flips the flag and this
 * unmounts).
 */
export function ForceChangePasswordModal() {
  const user = useAuthStore((s) => s.user);
  const open = !!user?.must_change_password;

  return (
    <Modal
      opened={open}
      onClose={() => undefined}
      title={
        <Text fw={600}>
          <IconLock size={16} style={{ verticalAlign: 'middle', marginRight: 6 }} />
          Set a new password before continuing
        </Text>
      }
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      centered
      size="md"
      overlayProps={{ backgroundOpacity: 0.55, blur: 2 }}
    >
      <Stack gap="md">
        <Alert color="pine" variant="light">
          An administrator issued you a one-time password. Please choose your own before using the
          application.
        </Alert>
        <ChangePasswordForm submitLabel="Set password" />
      </Stack>
    </Modal>
  );
}
